import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Box,
  Button,
  Divider,
  Flex,
  HStack,
  Image,
  Input,
  Spinner,
  Stack,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useLogin } from "../../hooks/useLogin";
import { effiMateLogo } from "../../helper/Images";
import {
  FaChartSimple,
  FaConnectdevelop,
  FaLock,
  FaUserLock,
} from "react-icons/fa6";

const getRandomUrlString = () => {
  let baseUrl = "https://idpdecathlon.oxylane.com/assets/images/";
  let randomImg = Math.floor(Math.random() * 14) + 1;
  let finalUrl = baseUrl + randomImg + ".jpg";
  return 'url("' + finalUrl + '")';
};
const url = getRandomUrlString();
function Login() {
  const [searchParams] = useSearchParams();
  const { getToken, onLogin, onEmailLogin, email, setEmail, isLoading } =
    useLogin();
  useEffect(() => {
    const code = searchParams.get("code");

    if (code) {
      getToken(code);
    }
  }, [searchParams, getToken]);

  return (
    <Flex minH="100vh" bg="gray.50">
      <Flex
        w={{ base: "100%", lg: "440px" }}
        bg="white"
        px="10"
        py="12"
        direction="column"
        justify="center"
        boxShadow="xl"
        zIndex="1"
        textAlign={"center"}
      >
        <Image src={effiMateLogo} alt="" maxW="120px" mx="auto" mb="4" />

        <Text fontSize="3xl" fontWeight="700" color="gray.800">
          Welcome Back!
        </Text>

        <Text color="gray.500" mb="8">
          Please login to continue
        </Text>

        <Button size="lg" colorScheme="blue" mb="6" onClick={onLogin}>
          Login with FEDID
        </Button>

        {(process.env.REACT_APP_ENV || "").toLowerCase() !== "prod" && (
          <>
            <Stack mb="6" position={"relative"}>
              <Divider position={"absolute"} left={0} right={0} top={"50%"} />
              <Text
                fontSize={"xs"}
                fontWeight={"medium"}
                background={"gray.100"}
                mx={"auto"}
                p={"1"}
                rounded={"full"}
                zIndex={"1"}
                width={"10"}
              >
                OR
              </Text>
            </Stack>

            <Input
              size={"md"}
              textAlign={"center"}
              value={email}
              placeholder="Enter Email"
              mb="2"
              onChange={(e) => setEmail(e.target.value.trim())}
            />

            <Button size="lg" variant="outline" onClick={onEmailLogin}>
              {isLoading ? <Spinner /> : "Login with Email"}
            </Button>
          </>
        )}

        <Text mt="10" fontSize="sm" color="gray.500" textAlign="center">
          Employee Management Platform
        </Text>
      </Flex>

      <Stack
        flex="1"
        display={{ base: "none", lg: "flex" }}
        bgImage={`
        linear-gradient(
          #027DBC33,
          #027DBC80
        ),
        ${url}
      `}
        bgSize="cover"
        bgPosition="left"
        align="center"
      >
        <Stack color="white" width={"full"} height={"full"} p="24" gap={"8"}>
          <Text
            fontSize="6xl"
            fontWeight="800"
            lineHeight="1.1"
            textShadow={"0 0 8px gray"}
            fontStyle={"italic"}
          >
            SPORT FOR ALL,
            <br />
            ALL FOR SPORT
          </Text>
          <Flex
            background={"#027DBC"}
            rounded={"lg"}
            width={"100px"}
            height={"12px"}
            shadow={"md"}
          />
          <Text fontSize="lg" textShadow={"0 0 8px gray"} fontStyle={"italic"}>
            Empowering Decathlon teams through seamless employee management.
          </Text>
        </Stack>
        <HStack
          mt="auto"
          spacing="12"
          width={"full"}
          background={"#027DBC"}
          color={"white"}
          justifyContent={"center"}
        >
          {[
            {
              title: "Secure",
              desc: "Enterprise authentication",
              Icon: FaUserLock,
            },
            {
              title: "Efficient",
              desc: "Leave, roster & payroll",
              Icon: FaChartSimple,
            },
            {
              title: "Connected",
              desc: "Built for Decathlon teams",
              Icon: FaConnectdevelop,
            },
          ].map(({ title, desc, Icon }) => {
            return (
              <VStack key={title} px={"4"} py={"3"} align="start" gap={"0.5"}>
                <Flex gap={"2"} alignItems={"center"}>
                  <Text fontSize={"sm"}>
                    <Icon />
                  </Text>
                  <Text fontSize={"md"} fontWeight="bold">
                    {title}
                  </Text>
                </Flex>

                <Text fontSize={"xs"}>{desc}</Text>
              </VStack>
            );
          })}
        </HStack>
      </Stack>
    </Flex>
  );
}

export default Login;
